import React from "react";
import { DestinationTypeEnum } from "../../../../../enums/destination";
import {
  AllDestinations,
  GoogleDocsDestination,
} from "../../../../../models/destination";

// WordPress / Shopify: the post status. Google Docs has none: it shows whether the Google account is connected.
export const DestinationStatusColumn = ({
  destination,
}: {
  destination: AllDestinations;
}) => {
  if (destination.destinationTypeId === DestinationTypeEnum.GOOGLE_DOCS) {
    const { googleEmail, needsReconnect } = (
      destination as GoogleDocsDestination
    ).destination;
    if (needsReconnect) {
      return <div className="text-red-600">Reconnect needed</div>;
    }
    return googleEmail ? (
      <div className="text-green-600">Connected</div>
    ) : (
      <div className="text-gray-500">Not connected</div>
    );
  }
  return (
    <div>{(destination.destination as { status?: string }).status ?? ""}</div>
  );
};
